import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FLXLoadingSpinnerInlineComponent } from './loading-spinner-inline.component';
@NgModule({
	imports: [CommonModule],
	declarations: [FLXLoadingSpinnerInlineComponent],
	exports: [FLXLoadingSpinnerInlineComponent]
})
export class FLXLoadingSpinnerInlineModule {}
